import { Cart } from 'shared/types/cart';
import { getProductsFromLineItems } from '../index';
import { centsToDollars, getPriceDetailsFromCart } from '../price';
import { sendGTMEvent } from '../send-gtm-event';

export const fireCheckoutStarted = (cart: Cart): void => {
  const { cartId, discountCodes, lineItems, sum } = cart;
  const { lineItemsTaxed, discountInDollars } = getPriceDetailsFromCart(cart);

  sendGTMEvent({
    event: 'Checkout Started',
    properties: {
      track_plan_id: 29,
      trigger_source: 'client-side',
      cart_id: cartId,
      checkout_id: cartId,
      currency: sum.currencyCode ?? 'USD',
      revenue: centsToDollars(lineItemsTaxed.amount),
      coupon: discountCodes[discountCodes.length - 1]?.code ?? null,
      value: centsToDollars(lineItemsTaxed.grossAmount),
      discount: discountInDollars,
      products: getProductsFromLineItems(lineItems),
    },
  });
};
